import { render, staticRenderFns } from "./IBIInvestmentsPage.vue?vue&type=template&id=3a7713b2&scoped=true"
import script from "./IBIInvestmentsPage.vue?vue&type=script&lang=js"
export * from "./IBIInvestmentsPage.vue?vue&type=script&lang=js"
import style0 from "./IBIInvestmentsPage.vue?vue&type=style&index=0&id=3a7713b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7713b2",
  null
  
)

export default component.exports